<template>
<div id="bo-import-csv">
  <bo-import-logs :logs="imported.logs" />
  <modal v-model="columns.modal"
         title="Sélection des colonnes">
    <div class="form-group" v-for="(c, k) in mandatoryColumns" :key="k">
      <label class="" for="`${k}-col`">{{ c.name }}</label>
      <select v-model="columns.associated[c.field]"
              class="form-control">
        <option disabled value="">Colonne associée</option>
        <option v-for="(v, j) in columns.available" :key="`${k}-col-${j}`">
          {{ v }}
        </option>
      </select>
    </div>
    <collapse v-model="columns.error.error">
      <alert type="danger">
        <strong>{{ columns.error.title }}</strong>
        <p v-for="(e, i) in columns.error.text" :key="i">{{ e }}</p>
      </alert>
    </collapse>
    <div slot="footer">
      <btn @click="columns.modal = false">Annuler</btn>
      <btn @click="checkSelectedColumns" type="primary">Confirmer</btn>
    </div>
  </modal>

  <modal v-model="merge.modal" :keyboard="false" :backdrop="false"
         :dismiss-btn="false" title="Fusion de deux utilisateurs">
    Deux utilisateurs portent le même nom et le même prénom :
    <br /><br />
    <strong>{{ merge.newUser.firstName }} {{ merge.newUser.name }}</strong>
    <br /><br />
    mais des adresses e-mail différentes :  <br /><br />
    <strong>{{ merge.existingUser.email }}</strong><br /><br />
    <strong>{{ merge.newUser.email }}</strong> <br /><br />
    Souhaitez vous fusionner les emails, ignorer l'utilisateur ou
    en créer un nouveau ?
    <div slot="footer">
      <btn type="warning" @click="mergeModalEnded('ignore')">Ignorer</btn>
      <btn type="info" @click="mergeModalEnded('new')">Créer</btn>
      <btn type="primary" @click="mergeModalEnded('merge')">Fusionner</btn>
    </div>
  </modal>
</div>
</template>

<script>
import boImportLogs from '@/components/import/logs'
import parse from 'csv-parse'
import tools from '@/sui/tools/main'

export default {
  name: 'bo-import-csv',

  props: {
    mandatoryColumns: Array,
    csvFile: File
  },

  data () {
    return {
      columns: {
        modal: false,
        error: {
          title: '',
          text: [],
          error: false
        },
        available: [],
        associated: []
      },

      merge: {
        modal: false,
        newUser: {},
        existingUser: {}
      },

      imported: {
        data: [],
        result: [],
        index: 0,
        resultIndex: 0,
        logs: []
      }
    }
  },

  watch: {
    csvFile (value) {
      if (value == null) {
        return
      }
      this.columns.available = []
      this.columns.associated = {}
      this.imported.data = []

      const file = value
      const reader = new FileReader()

      reader.onload = this.parseCSV
      reader.readAsText(file)
    }
  },

  methods: {
    parseCSV: function (e) {
      const instance = this
      parse(e.target.result, {
        comment: '#',
        columns: true,
        delimiter: ';',
        skip_empty_lines: true
      }, function (err, output) {
        if (err != null) {
          instance.$notify({
            type: 'danger',
            title: 'Erreur !',
            content: `Impossible de charger le fichier csv: ${err}.`
          })
        } else if (output.length === 0) {
          instance.$notify({
            type: 'warning',
            title: 'Attention !',
            content: `Le fichier ne contient aucune donnée.`
          })
        } else {
          instance.columns.modal = true
          instance.columns.available = Object.keys(output[0])
          instance.imported.data = output
        }
      })
    },

    checkSelectedColumns: function () {
      let error = false
      let txt = []
      let selection = []
      for (let i in this.mandatoryColumns) {
        const c = this.mandatoryColumns[i].name
        const d = this.mandatoryColumns[i].field
        const a = this.columns.associated[d]
        if (a == null) {
          error = true
          txt.push(`La colonne ${c} n'a pas été associée.`)
        } else if (selection.includes(a)) {
          error = true
          txt.push(`La colonne importée ${a} est associée plusieurs fois.`)
        } else {
          selection.push(a)
        }
      }

      this.columns.error.error = error
      this.columns.error.title = 'Erreur'
      this.columns.error.text = txt

      if (!error) {
        this.columns.modal = false
        this.importData()
      }
    },

    importData: function () {
      this.imported.result = []
      this.imported.index = 0
      this.imported.resultIndex = 0
      this.continueImport()
    },

    continueImport: function () {
      const count = this.imported.data.length
      while (this.imported.index < count) {
        const importedUser = this.imported.data[this.imported.index]
        let user = { info: [ {} ] }
        for (let i in this.columns.available) {
          const c = this.columns.available[i]
          const pos = Object.values(this.columns.associated).findIndex(
            e => { return e === c }
          )
          if (pos === -1) {
            user.info[0][c] = importedUser[c].trim()
          } else {
            user[Object.keys(this.columns.associated)[pos]] = importedUser[c].trim()
          }
        }
        user.email = user.email.split(',')

        user.id = this.imported.result.length
        if (user.roles != null) {
          user.roles = user.roles.split(',')
        }
        for (let i in user.email) {
          user.email[i] = user.email[i].trim()
          if (!tools.isEmailValid(user.email[i])) {
            user.email = []
            break
          }
        }
        if (user.email.length === 0) {
          this.imported.logs.push({
            text: `Email vide : ${user.firstName} ${user.name} ${user.email}`,
            type: 'danger'
          })
          ++this.imported.index
          continue
        }

        let valid = true
        const importCount = this.imported.result.length
        for (;this.imported.resultIndex < importCount; ++this.imported.resultIndex) {
          const resultUser = this.imported.result[this.imported.resultIndex]
          const containsEmail = resultUser.email.findIndex(e => {
            for (let i in user.email) {
              if (e === user.email[i]) {
                return true
              }
            }
            return false
          }) !== -1

          if (user.name === resultUser.name &&
              user.firstName === resultUser.firstName) {
            if (containsEmail) {
              this.imported.logs.push({
                text: `Doublon ignoré : ${user.firstName} ${user.name} ${user.email}`,
                type: 'info'
              })
              valid = false
              break
            } else {
              this.merge.newUser = user
              this.merge.existingUser = resultUser
              this.merge.modal = true
              return
            }
          } else if (containsEmail) {
            this.imported.logs.push({
              text: `Email déjà présent : ${user.firstName} ${user.name} ${user.email},
${resultUser.firstName} ${resultUser.name} ${resultUser.email}`,
              type: 'danger'
            })
            valid = false
            break
          }
        }
        if (valid) {
          this.imported.result.push(user)
        }
        ++this.imported.index
        this.imported.resultIndex = 0
      }

      this.columns.available = []
      this.columns.associated = {}
      this.imported.data = []
      this.$notify({
        type: 'success',
        title: 'Succès !',
        content: `${this.imported.result.length} lignes importées avec succès.`
      })
      this.$emit('import-ok', this.imported.result)
      this.imported.result = []
    },

    mergeModalEnded (msg) {
      if (msg === 'merge') {
        for (let i in this.merge.newUser.email) {
          this.merge.existingUser.email.push(this.merge.newUser.email[i])
        }
        this.merge.existingUser.info.push(this.merge.newUser.info[0])
        ++this.imported.index
        this.imported.resultIndex = 0
      } else if (msg === 'new') {
        ++this.imported.resultIndex
      } else if (msg === 'ignore') {
        ++this.imported.index
        this.imported.resultIndex = 0
      }
      this.merge.modal = false

      setTimeout(this.continueImport, 10)
    }
  },

  components: {
    'bo-import-logs': boImportLogs
  }
}
</script>

<style scoped lang="less">
</style>
